/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignRequestSender
 */
export interface SignRequestSender {
    /**
     * The unique identifier of the sender's DocuSign account
     * @type {string}
     * @memberof SignRequestSender
     */
    accountId?: string;
    /**
     * The name of the sender's DocuSign account
     * @type {string}
     * @memberof SignRequestSender
     */
    accountName?: string;
    /**
     * The URI that identifies the user resource to access. Typically refers to the currently authenticated user, but for administrators it may reference another user they are managing
     * @type {string}
     * @memberof SignRequestSender
     */
    uri?: string;
    /**
     * The current status of the user’s account
     * @type {string}
     * @memberof SignRequestSender
     */
    userStatus?: string;
    /**
     * The type or role of the user
     * @type {string}
     * @memberof SignRequestSender
     */
    userType?: string;
    /**
     * The email address of the user
     * @type {string}
     * @memberof SignRequestSender
     */
    email?: string;
    /**
     * The unique identifier of the user
     * @type {string}
     * @memberof SignRequestSender
     */
    userId?: string;
    /**
     * The full name of the user
     * @type {string}
     * @memberof SignRequestSender
     */
    userName?: string;
}

/**
 * Check if a given object implements the SignRequestSender interface.
 */
export function instanceOfSignRequestSender(value: object): boolean {
    return true;
}

export function SignRequestSenderFromJSON(json: any): SignRequestSender {
    return SignRequestSenderFromJSONTyped(json, false);
}

export function SignRequestSenderFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestSender {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'accountName': json['accountName'] == null ? undefined : json['accountName'],
        'uri': json['uri'] == null ? undefined : json['uri'],
        'userStatus': json['userStatus'] == null ? undefined : json['userStatus'],
        'userType': json['userType'] == null ? undefined : json['userType'],
        'email': json['email'] == null ? undefined : json['email'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
    };
}

export function SignRequestSenderToJSON(value?: SignRequestSender | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'accountName': value['accountName'],
        'uri': value['uri'],
        'userStatus': value['userStatus'],
        'userType': value['userType'],
        'email': value['email'],
        'userId': value['userId'],
        'userName': value['userName'],
    };
}

